import React from 'react';
import { useAuth } from '@store/authStore';
import MyWork from '@pages/employee/MyWork';
import AdminDailyLog from '@pages/admin/DailyLog';
import PMDailyLog from '@pages/programManager/DailyLog';
import HRDailyLog from '@pages/hr/HRDailyLog';

const DailyLogRouter: React.FC = () => {
  const { user } = useAuth();

  console.log('DailyLogRouter: User role:', user?.role);

  // Render daily log based on user role
  if (user?.role === 'Admin') {
    console.log('DailyLogRouter: Rendering Admin Daily Log');
    return <AdminDailyLog />;
  }

  if (user?.role === 'HR') {
    console.log('DailyLogRouter: Rendering HR Daily Log');
    return <HRDailyLog />;
  }

  if (user?.role === 'Employee') {
    console.log('DailyLogRouter: Rendering Employee Daily Log');
    return <MyWork />;
  }

  if (user?.role === 'Program Manager') {
    console.log('DailyLogRouter: Rendering Program Manager Daily Log');
    return <PMDailyLog />;
  }

  // Default to Employee view for unknown roles
  console.log('DailyLogRouter: Rendering default Employee Daily Log');
  return <MyWork />;
};

export default DailyLogRouter;
